export const chat = () => (
  <path
    d="M21 12a9 9 0 01-9 9H3s1.125-1.08 2.659-2.613A9 9 0 1121 12z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
